import gql from 'graphql-tag'
import client from '@stores/apollo'

interface Payload {
  data: {
    viewer: {
      company: {
        mapping: {
          buildingImportTemplateFile: string
        }
      }
    }
  }
}

export default function template(): Promise<string> {
  return client.gql.query({ query }).then(
    ({
      data: {
        viewer: {
          company: {
            mapping: { buildingImportTemplateFile },
          },
        },
      },
    }: Payload) => buildingImportTemplateFile
  )
}

const query = gql`
  query BuildingImportTemplate {
    viewer {
      company {
        mapping {
          buildingImportTemplateFile
        }
      }
    }
  }
`
